<template>
  <panel :title="account.shopName">
    <span slot="header-right" :class="authenticated ? 'badge badge--success' : 'badge badge--danger'">{{ authenticated ? 'Autenticado' : 'Não Autenticado'}}</span> 
    <loader :loading="authenticating" label="Autenticando..."/>
    <div>
      <div class="l-row">
        <div class="l-col-12@md img-account">
          <img v-if="account.logo" :src="account.logo"/>
          <i v-if="!account.logo" class="icon-image2 no-photo"/>
        </div>
        <div v-if="blockedAccount()">
          <h5><span class="c-alert--danger">Conta com recursos bloqueados</span></h5>
          <p>Siga o passo-a-passo abaixo</p>
          <p><strong>1</strong>) Por favor, entre em <a href="https://sellercentral.amazon.com.br/hz/sc/account-information" alt="Seller Central - Account Information">
            Seller Central - Account Information</a>
          </p>
          <p><strong>2</strong>) Após regularizar, clique no botão abaixo</p>
          <button @click="solveAccount" class="btn btn--smart btn--sm btn--info">
            Confirmar solução de pendência no Seller Central
          </button>
        </div>
      </div>
    </div>

    <footer class="c-card__footer u-textLeft l-level">
      <button @click="editAction" class="btn btn--smart btn--sm btn--info l-level__left">
        {{ $t('edit.label') }}
      </button>
      <button @click="modalDeleteAccountFlag = true" slot="header-actions" class="header-right btn btn--smart btn--sm btn--danger l-level__right">
        {{ $t('delete.label') }}
      </button>
    </footer>
    <modal-delete-account v-model="modalDeleteAccountFlag" v-on:confirm="deleteAccount"/>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import api from '@/api'
  import ModalDeleteAccount from '@/components/marketplace/amazon/ModalDeleteAccount'
  import apiAmazon from '@/api/marketplace/amazon'
  import notifier from '@/notifier'

  export default {
    props: {
      account: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      authenticating: true,
      authenticated: false,
      modalDeleteAccountFlag: false
    }),
    async mounted () {
      api.amazon.checkApiStatus(
        this.account.partnerId
      )
      .then(result => {
        this.authenticated = result
      })
      .then(() => {
        this.authenticating = false
      })
    },
    methods: {
      async solveAccount () {
        try {
          await api.amazon.resetAccountTries(this.account.partnerId)

          this.account.tries = 0

          this.blockedAccount()

          notifier.success(`Envio de feeds liberados para envio.`, 'Sucesso')
        } catch (error) {
          notifier.error('Erro na alteração de status da conta.', 'Erro')
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'amazon.accounts.active.label'
        }
        return 'amazon.accounts.inactive.label'
      },
      blockedAccount () {
        if (this.account.tries > 5) {
          return true
        }
        return false
      },
      editAction () {
        return this.$router.push(`/marketplace/amazon/accounts/` + this.account.partnerId)
      },
      async deleteAccount () {
        this.loading = true

        await apiAmazon.deleteAccountByPartnerId(this.account.partnerId)
          .then((productReprocessed) => {
            this.modalDeleteAccountFlag = false
            let message = 'Conta deletada com sucesso!'
            notifier.success(message, 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao deletar conta!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })

        await new Promise(resolve => setTimeout(resolve, 1000))
        window.location.reload()
      }
    },
    components: {
      Panel,
      Loader,
      ModalDeleteAccount
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

  .no-photo
    font-size: 150px
    color: darkgrey
</style>



// WEBPACK FOOTER //
// Account.vue?21d600a0